import iconsMap from "src/assets/iconsMap";

const getIcon = (iconText) => {
  if (iconText === "UK") return "GB".toLowerCase();
  return iconText.toLowerCase();
};

export default function generateIcon(iconText) {
  const imagesUrl =
    "https://test.asosservices.com/assets/storesa/images/flags/";
  let icon = "";
  if (iconText === "ROW" || iconText === "ROE") {
    icon = iconsMap(iconText);
  } else if (iconText.length === 2) {
    icon = `${imagesUrl}${getIcon(iconText)}.png`;
  } else {
    icon = "";
  }
  return icon;
}
